import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "ሞባይል አፕ | Mobile App",
          "ዌብሳይት | Website",
          "ሎጎ | Logo",
          "ግራፊክስ | Graphics",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
